(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["model-3d-image"] && !Shopify.designMode) return;
  try {
    (() => {
  // Bundled once by Shopify, reused by every instance of this theme block.
  const selector = '[data-model3d-root]';
  let modelViewerModule;

  function loadComponent() {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!modelViewerModule) {
      // Version pinned intentionally: newer CDN releases cannot silently change behavior.
      modelViewerModule = import('https://ajax.googleapis.com/ajax/libs/model-viewer/3.0.0/model-viewer.min.js')
        .then(() => customElements.whenDefined('model-viewer'));
    }
    return modelViewerModule;
  }

  function init(root) {
    if (root.dataset.model3dInitialized === 'true') return;
    const viewer = root.querySelector('model-viewer');
    if (!viewer) return;
    root.dataset.model3dInitialized = 'true';
    const controls = root.querySelector('.model3d__controls');
    const rotationOn = viewer.dataset.defaultRotation === 'true';
    const animationOn = viewer.dataset.defaultAnimation === 'true';
    const originalOrbit = viewer.getAttribute('camera-orbit');
    const originalFov = viewer.getAttribute('field-of-view');
    const reducedMotion = viewer.dataset.respectMotion === 'true' &&
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      viewer.removeAttribute('auto-rotate');
      viewer.removeAttribute('autoplay');
    }
    let active = !reducedMotion && (rotationOn || animationOn);
    const motionButton = root.querySelector('[data-model3d-action="motion"]');

    function updateMotionButton() {
      if (!motionButton) return;
      motionButton.textContent = active ? 'Ⅱ' : '▶';
      motionButton.setAttribute('aria-label', active ? 'Pause motion' : 'Play motion');
      motionButton.title = active ? 'Pause motion' : 'Play motion';
    }
    updateMotionButton();

    function fail() {
      root.classList.remove('model3d--ready');
      root.classList.add('model3d--failed');
      if (controls) controls.hidden = true;
    }
    viewer.addEventListener('error', fail);
    viewer.addEventListener('load', () => {
      if (!root.isConnected) return;
      root.classList.remove('model3d--failed');
      root.classList.add('model3d--ready');
      if (controls) controls.hidden = false;
    });

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-model3d-action]');
      if (!button || !root.contains(button)) return;
      const action = button.dataset.model3dAction;
      if (action === 'zoom-in' && typeof viewer.zoom === 'function') viewer.zoom(1.5);
      if (action === 'zoom-out' && typeof viewer.zoom === 'function') viewer.zoom(-1.5);
      if (action === 'reset') {
        // Move away from previous value first, so it also resets after user dragging.
        viewer.cameraOrbit = originalOrbit;
        viewer.fieldOfView = originalFov;
        if (typeof viewer.resetTurntableRotation === 'function') viewer.resetTurntableRotation();
        if (typeof viewer.jumpCameraToGoal === 'function') viewer.jumpCameraToGoal();
      }
      if (action === 'motion') {
        active = !active;
        if (active) {
          if (rotationOn) viewer.setAttribute('auto-rotate', '');
          if (animationOn) {
            viewer.setAttribute('autoplay', '');
            if (typeof viewer.play === 'function') viewer.play();
          }
        } else {
          viewer.removeAttribute('auto-rotate');
          if (animationOn) {
            viewer.removeAttribute('autoplay');
            if (typeof viewer.pause === 'function') viewer.pause();
          }
        }
        updateMotionButton();
      }
    });
    if (!('WebGLRenderingContext' in window)) { fail(); return; }
    loadComponent().catch(fail); // Failed script download keeps the actual image visible.
  }

  function scan(scope) {
    if (scope.matches && scope.matches(selector)) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:block:select', event => scan(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    if (!window.__productSizeGuideEvents) {

  window.__productSizeGuideEvents = true;


  function psgActivateTab(tab, shouldFocus) {

    const guide = tab.closest('[data-size-guide]');

    if (!guide) return;


    const tabs = Array.from(
      guide.querySelectorAll('.psg__tab')
    );

    const panels = Array.from(
      guide.querySelectorAll('.psg__panel')
    );

    const targetPanelId =
      tab.getAttribute('aria-controls');


    tabs.forEach((item) => {

      const active = item === tab;

      item.classList.toggle(
        'is-active',
        active
      );

      item.setAttribute(
        'aria-selected',
        active ? 'true' : 'false'
      );

      item.setAttribute(
        'tabindex',
        active ? '0' : '-1'
      );

    });


    panels.forEach((panel) => {

      const active =
        panel.id === targetPanelId;

      panel.classList.toggle(
        'is-active',
        active
      );

      panel.hidden = !active;

    });


    tab.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });


    if (shouldFocus) {
      tab.focus();
    }

  }



  document.addEventListener(
    'click',
    function(event) {

      const tab =
        event.target.closest('.psg__tab');

      if (!tab) return;

      psgActivateTab(
        tab,
        false
      );

    }
  );



  document.addEventListener(
    'keydown',
    function(event) {

      const currentTab =
        event.target.closest('.psg__tab');

      if (!currentTab) return;


      const guide =
        currentTab.closest('[data-size-guide]');

      if (!guide) return;


      const tabs = Array.from(
        guide.querySelectorAll('.psg__tab')
      );

      const currentIndex =
        tabs.indexOf(currentTab);

      if (currentIndex < 0) return;


      let nextIndex = null;


      if (event.key === 'ArrowRight') {

        nextIndex =
          (currentIndex + 1) % tabs.length;

      }

      else if (event.key === 'ArrowLeft') {

        nextIndex =
          (currentIndex - 1 + tabs.length)
          % tabs.length;

      }

      else if (event.key === 'Home') {

        nextIndex = 0;

      }

      else if (event.key === 'End') {

        nextIndex =
          tabs.length - 1;

      }


      if (nextIndex === null) return;


      event.preventDefault();


      psgActivateTab(
        tabs[nextIndex],
        true
      );

    }
  );

}
  } catch(e) { console.error(e); }
})();

})();
